"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSource = void 0;
const constants_1 = require("./constants");
function crumbleCookie(a) {
    const rawCookie = document.cookie.split(';');
    const formattedCookie = {};
    for (let counter = 0; counter < rawCookie.length; counter++) {
        const cookieKey = rawCookie[counter]
            .substring(0, rawCookie[counter].indexOf('='))
            .trim();
        const cookieValue = rawCookie[counter]
            .substring(rawCookie[counter].indexOf('=') + 1, rawCookie[counter].length)
            .trim();
        formattedCookie[cookieKey] = cookieValue;
    }
    if (a)
        return formattedCookie[a] ? formattedCookie[a] : null;
    return formattedCookie;
}
function bakeCookie(cookieName, trafficSourceInformation, cookieExpireDate, path, domain, isSecure) {
    let currentDate = new Date();
    currentDate.setTime(currentDate.getTime());
    cookieExpireDate && (cookieExpireDate *= 864e5);
    currentDate = new Date(currentDate.getTime() + cookieExpireDate);
    document.cookie =
        cookieName +
            '=' +
            escape(trafficSourceInformation) +
            (cookieExpireDate ? ';expires=' + currentDate.toUTCString() : '') +
            (path ? ';path=' + path : '') +
            (domain ? ';domain=' + domain : '') +
            (isSecure ? ';secure' : '');
}
function writeLogic(cookieName, domain) {
    const trafficInformation = getTrafficSource();
    let cookieInformation = trafficInformation.value.replace(/\|{2,}/g, '|');
    cookieInformation = cookieInformation.replace(/^\|/, '');
    cookieInformation = decodeURI(cookieInformation);
    bakeCookie(cookieName, cookieInformation, 182, '/', domain, false); //Cookie expiration sets to 182 days
    return trafficInformation.source;
}
function getParam(url, queryParam) {
    try {
        const match = url.match('[?&]' + queryParam + '=([^&]+)');
        return match ? match[1] : '';
    }
    catch (e) {
        return '';
    }
}
function findSource(utmMedium, utmCampaign, utmSource, sourceParam, gclid, refDomain) {
    if (utmMedium === 'social' &&
        constants_1.SOCIAL_MEDIA_SITES.filter((site) => utmSource.includes(site) || utmSource.includes(refDomain)).length > 0)
        return 'Organic social';
    if (utmSource.includes('email') ||
        utmMedium.includes('email') ||
        utmCampaign.includes('email') ||
        sourceParam.includes('email'))
        return 'Email marketing';
    if (constants_1.PAID_SEARCHES.filter((search) => sourceParam.includes(search)).length > 0)
        return 'Paid Search';
    if (gclid)
        return 'Paid Search';
    if ((constants_1.PAID_SOCIAL.filter((social) => utmMedium.includes(social)).length > 0 &&
        constants_1.SOCIAL_MEDIA_SITES.filter((social) => utmSource.includes(social) || refDomain.includes(social)).length > 0) ||
        utmSource.includes('paidsocial') ||
        utmMedium.includes('paidsocial'))
        return 'Paid social';
    if (utmSource || utmMedium || (utmCampaign && refDomain === 'google.com'))
        return 'Paid Search';
    if (utmSource ||
        utmMedium ||
        (utmCampaign &&
            constants_1.PAID_SEARCHES.filter((search) => utmSource.includes(search) ||
                utmCampaign.includes(search) ||
                utmMedium.includes(search)).length > 0))
        return 'Paid Search';
    if (utmSource ||
        utmMedium ||
        utmCampaign ||
        (sourceParam &&
            constants_1.OTHER_CAMPAIGNS.filter((campaign) => !(utmSource.includes(campaign) ||
                utmCampaign.includes(campaign) ||
                utmMedium.includes(campaign) ||
                sourceParam.includes(campaign))).length > 0))
        return 'Other campaigns';
    if (constants_1.SOCIAL_MEDIA_SITES.filter((social) => refDomain.includes(social)).length > 0)
        return 'Organic social';
    if (constants_1.SEARCH_ENGINES.filter((engine) => refDomain.includes(engine)).length > 0)
        return 'Organic search';
    if (constants_1.SEARCH_ENGINES.filter((engine) => refDomain.includes(engine)).length ===
        0 &&
        constants_1.SOCIAL_MEDIA_SITES.filter((social) => refDomain.includes(social)).length ===
            0)
        return 'Referral';
    return 'Direct traffic';
}
function calculateTrafficSource() {
    const ref = document.referrer;
    const refDomain = ref.slice(ref.indexOf('//') + 2);
    const urlSearch = document.location.search;
    const utmMedium = urlSearch.indexOf('utm_medium') > -1
        ? getParam(urlSearch, 'utm_medium')
        : '';
    const utmCampaign = urlSearch.indexOf('utm_campaign') > -1
        ? getParam(urlSearch, 'utm_campaign')
        : '';
    const utmSource = urlSearch.indexOf('utm_source') > -1
        ? getParam(urlSearch, 'utm_source')
        : '';
    const sourceParam = urlSearch.indexOf('source') > -1 ? getParam(urlSearch, 'source') : '';
    const gclid = urlSearch.indexOf('gclid') > -1 ? getParam(urlSearch, 'gclid') : '';
    const source = findSource(utmMedium, utmCampaign, utmSource, sourceParam, gclid, refDomain);
    return {
        source,
    };
}
function getTrafficSource() {
    const trafficSources = calculateTrafficSource();
    const source = trafficSources.source;
    const rightNow = new Date();
    const value = 'source=' +
        source +
        '&date=' +
        rightNow.toISOString().slice(0, 10).replace(/-/g, '');
    return { value, source };
}
function getSource(domain = '') {
    const session = crumbleCookie()['FirstSession'];
    if (typeof session == 'undefined') {
        // First time session
        return writeLogic('FirstSession', domain);
    }
    else {
        return writeLogic('ReturningSession', domain);
    }
}
exports.getSource = getSource;
//# sourceMappingURL=source-traffic.js.map